import type { ITransactionImport, ITransactionImportError } from "@types";

export type TransactionImportPhase = "idle" | "uploading" | "processing" | "finished" | "rejected";

export interface TransactionImportRejection {
  status?: number;
  code?: string;
  detail?: string;
}

export interface TransactionImportState {
  phase: TransactionImportPhase;
  fileName: string;
  importData: ITransactionImport | null;
  errors: ITransactionImportError[];
  rejection: TransactionImportRejection | null;
}

export const INITIAL_IMPORT_STATE: TransactionImportState = {
  phase: "idle",
  fileName: "",
  importData: null,
  errors: [],
  rejection: null,
};

export const hasImportErrors = (data: ITransactionImport) =>
  data.status === "FAILED" || (data.summary?.discardedRows ?? 0) > 0;

export const isImportSettled = (state: TransactionImportState) =>
  state.phase === "finished" || state.phase === "rejected";

export const toImportRejection = (error: unknown): TransactionImportRejection => {
  const response = (error as { response?: { status?: number; data?: Record<string, unknown> } })?.response;
  const data = response?.data ?? {};

  return {
    status: response?.status,
    code: typeof data.code === "string" ? data.code : undefined,
    detail: typeof data.detail === "string" ? data.detail : undefined,
  };
};
